export const RESTRICTED_ROLE = 4;

export const RESTRICTED_METHODS = ['POST', 'PUT', 'PATCH', 'DELETE'];

export const RESTRICTED_ROUTES = [
  '/add-company',
  '/add-site',
  '/add-request',
  '/edit',
  '/edit-site',
  '/edit-request',
  '/settings',
  '/invoice',
];

// Write endpoints ARA users (role 4) are allowed to call
export const ARA_ALLOWED_WRITE_ENDPOINTS = [
  'assignedSiteAdminAndSiteManager',
  'addNewSitesContact',
  'reassign-request',
];

export const isARAAllowedEndpoint = (url = '') => {
  const lowerUrl = url.toLowerCase();
  return ARA_ALLOWED_WRITE_ENDPOINTS.some((endpoint) =>
    lowerUrl.includes(endpoint.toLowerCase())
  );
};